module.exports = __webpack_public_path__ + "img/grayscale_light.78b926e2.webp";